import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import {
  listFormsOptions,
  listTaxonomiesOptions,
} from '@/api/codegen/@tanstack/react-query.gen'
import { FORMS_DEFAULT_SEARCH } from '@/api/domain/form/form.constants'
import { FormsPage } from '@/pages/forms/Forms.page'

const SEARCH_SCHEMA = z.object({
  name: fallback(z.string(), FORMS_DEFAULT_SEARCH.name).default(
    FORMS_DEFAULT_SEARCH.name,
  ),
  sortBy: fallback(z.string(), FORMS_DEFAULT_SEARCH.sortBy).default(
    FORMS_DEFAULT_SEARCH.sortBy,
  ),
  createdAt: fallback(
    z.string().nullable(),
    FORMS_DEFAULT_SEARCH.createdAt,
  ).default(FORMS_DEFAULT_SEARCH.createdAt),
})

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/',
)({
  component: FormsPage,
  validateSearch: zodValidator(SEARCH_SCHEMA),
  loader: ({ context: { queryClient }, params: { projectId, spaceId } }) => {
    queryClient.ensureQueryData(
      listFormsOptions({
        path: {
          projectID: projectId,
        },
      }),
    )
    queryClient.ensureQueryData(
      listTaxonomiesOptions({
        path: {
          spaceID: spaceId,
        },
      }),
    )
  },
  search: {
    middlewares: [stripSearchParams(FORMS_DEFAULT_SEARCH)],
  },
})
